import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { Observable } from 'rxjs'
import { FormGroup } from '@angular/forms'

import { ClientsService } from '@app/modules/admin/clients/clients.service'
import { User } from '@shared/models/user.model'
import { AbstractApiDataSource } from '@app/core/services/abstract-api.datasource'
import { AdminTeamService } from '@app/modules/admin/admin-team/admin-team.service'
import { FilterValues } from '@shared/models/filter-values.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'

export class ClientUserListDatasource extends AbstractApiDataSource<User> {
  constructor(
    protected id: number | string,
    protected clientsService: ClientsService,
    protected adminTeamService: AdminTeamService,
    sort: MatSort,
    paginator: MatPaginator,
    form: FormGroup,
  ) {
    super(sort, paginator, form)
  }

  getApiData(sortValue: string, filterValues: { [p: string]: string | number }): Observable<any> {
    return this.clientsService.getClientUsers(this.id, this.paginator.pageIndex + 1, this.paginator.pageSize, sortValue, filterValues, [
      'team',
      'driverId',
      'picture',
      'position',
    ])
  }

  getApiFileData(columns: string[], sortValue: string, filterValues: FilterValues, type: ExportFileTypes): Observable<string> {
    return this.adminTeamService.exportFile(columns, sortValue, filterValues, type)
  }
}
